import React from "react";
import Index from "./index";
import UserTable from "./UserTable";

const InActiveUsers = () => {
    const { inActiveUsers, loading, history, search, setSearch } = Index();
    return (
        <UserTable
            heading="InActive Customers"
            allCustomers={inActiveUsers}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(InActiveUsers, comparisonFn);
